import { ERROR_PAGE } from '../../constants/pages';
import { attachPostRequestListener } from '../../request';
import history from '../utils/history';

export default () => (next) => (action) => {
  attachPostRequestListener((error) => {
    if (!error.response) {
      return Promise.reject(error);
    }
    if (error.response.status === 500) {
      // A request may opt out of the global redirect (e.g. SFH quotes, which
      // shows its own service-unavailable drawer) by setting this config flag.
      if (error.config?.skipInternalServerErrorRedirect) {
        return Promise.reject(error);
      }
      return history.push(ERROR_PAGE);
    }
    return Promise.reject(error);
  });

  next(action);
};
